import {FC, Fragment, Suspense} from 'react';
import {styled} from '@mui/material';
import {SUMMARY_TABS} from '../../constants/summary-tabs.constants';
import {TabPanel} from '@mui/lab';
import {useContractTabsSummaryStore} from '../../stores/contract-summary-tabs.store';
import {ContractGeneralInfo} from '../contract-general-info';
import {ContractDocuments} from '../contract-documents';
import {ContractDataImports} from '../contract-data-import';
import {ContractsSpinner} from '../contracts-spinner';
import {ContractRequests} from '../contract-requests';

const TAB_COMPONENTS = {
  [SUMMARY_TABS.APPLICATIONS]: <ContractRequests />,
  [SUMMARY_TABS.DOCUMENTS]: <ContractDocuments />,
  [SUMMARY_TABS.DATA_IMPORT]: <ContractDataImports />,
  [SUMMARY_TABS.GENERAL_INFO]: <ContractGeneralInfo />,
};

export const ContractSummaryPanels: FC = () => {
  const activeTab = useContractTabsSummaryStore(({activeTab}) => activeTab);

  return (
    <Fragment>
      {Object.values(SUMMARY_TABS).map((key) => (
        <Tab key={key} value={key}>
          <Suspense key={key} fallback={<ContractsSpinner />}>
            {TAB_COMPONENTS[activeTab]}
          </Suspense>
        </Tab>
      ))}
    </Fragment>
  );
};

const Tab = styled(TabPanel)({
  position: 'relative',
  padding: '32px 16px 8px',
  minHeight: 580,
});
